module.exports = __webpack_public_path__ + "img/getOut.b2790d37.svg";